/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vpn_Feature_4Inputs */

const en_vpn_feature_4 = /** @type {(inputs: Vpn_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desktop, Android, & iOS`)
};

const id_vpn_feature_4 = /** @type {(inputs: Vpn_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desktop, Android, & iOS`)
};

const ms_vpn_feature_4 = /** @type {(inputs: Vpn_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desktop, Android, & iOS`)
};

const ca_vpn_feature_4 = /** @type {(inputs: Vpn_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escriptori, Android i iOS`)
};

const cs_vpn_feature_4 = /** @type {(inputs: Vpn_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Počítač, Android a iOS`)
};

const da_vpn_feature_4 = /** @type {(inputs: Vpn_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desktop, Android og iOS`)
};

const de_vpn_feature_4 = /** @type {(inputs: Vpn_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desktop, Android & iOS`)
};

const et_vpn_feature_4 = /** @type {(inputs: Vpn_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Töölauaarvuti, Android ja iOS`)
};

const es_vpn_feature_4 = /** @type {(inputs: Vpn_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Computadoras, Android y iOS`)
};

const fr_vpn_feature_4 = /** @type {(inputs: Vpn_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordinateur, Android et iOS`)
};

const hr_vpn_feature_4 = /** @type {(inputs: Vpn_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desktop, Android i iOS`)
};

const it_vpn_feature_4 = /** @type {(inputs: Vpn_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desktop, Android e iOS`)
};

const lv_vpn_feature_4 = /** @type {(inputs: Vpn_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Galddatoriem, Android un iOS ierīcēm`)
};

const lt_vpn_feature_4 = /** @type {(inputs: Vpn_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Staliniams kompiuteriams, „Android“ ir „iOS“ įrenginiams`)
};

const hu_vpn_feature_4 = /** @type {(inputs: Vpn_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desktop, Android és iOS`)
};

const nl_vpn_feature_4 = /** @type {(inputs: Vpn_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desktop, Android en iOS`)
};

const nb_vpn_feature_4 = /** @type {(inputs: Vpn_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desktop, Android og iOS`)
};

const pl_vpn_feature_4 = /** @type {(inputs: Vpn_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Komputery, Android i iOS`)
};

const pt_vpn_feature_4 = /** @type {(inputs: Vpn_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desktop, Android e iOS`)
};

const ro_vpn_feature_4 = /** @type {(inputs: Vpn_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desktop, Android și iOS`)
};

const sk_vpn_feature_4 = /** @type {(inputs: Vpn_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Počítač, Android a iOS`)
};

const sl_vpn_feature_4 = /** @type {(inputs: Vpn_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namizje, Android in iOS`)
};

const fi_vpn_feature_4 = /** @type {(inputs: Vpn_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pöytätietokone, Android ja iOS`)
};

const sv_vpn_feature_4 = /** @type {(inputs: Vpn_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desktop, Android och iOS`)
};

const vi_vpn_feature_4 = /** @type {(inputs: Vpn_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Máy tính, Android và iOS`)
};

const tr_vpn_feature_4 = /** @type {(inputs: Vpn_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masaüstü, Android ve iOS`)
};

const el_vpn_feature_4 = /** @type {(inputs: Vpn_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desktop, Android, & iOS`)
};

const bg_vpn_feature_4 = /** @type {(inputs: Vpn_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`За компютър, Android и iOS`)
};

const ru_vpn_feature_4 = /** @type {(inputs: Vpn_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Настольные компьютеры, Android и iOS`)
};

const sr_vpn_feature_4 = /** @type {(inputs: Vpn_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Десктоп, Android и iOS`)
};

const uk_vpn_feature_4 = /** @type {(inputs: Vpn_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ПК, Android та iOS`)
};

const ka_vpn_feature_4 = /** @type {(inputs: Vpn_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`დესკტოპი, Android და iOS`)
};

const hi_vpn_feature_4 = /** @type {(inputs: Vpn_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`डेस्कटॉप, एंड्राइड और आईओएस `)
};

const th_vpn_feature_4 = /** @type {(inputs: Vpn_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เดสก์ท็อป, แอนดรอยด์, และ iOS`)
};

const ko_vpn_feature_4 = /** @type {(inputs: Vpn_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`데스크톱, Android, iOS`)
};

const zh_vpn_feature_4 = /** @type {(inputs: Vpn_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`支持桌面、Android 和 iOS 设备`)
};

const zh_tw_vpn_feature_4 = /** @type {(inputs: Vpn_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`桌上型電腦、Android 和 iOS`)
};

const ja_vpn_feature_4 = /** @type {(inputs: Vpn_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デスクトップ、Android、iOS対応`)
};

/**
* | output |
* | --- |
* | "Desktop, Android, & iOS" |
*
* @param {Vpn_Feature_4Inputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const vpn_feature_4 = /** @type {((inputs?: Vpn_Feature_4Inputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vpn_Feature_4Inputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_vpn_feature_4(inputs)
	if (locale === "ms") return ms_vpn_feature_4(inputs)
	if (locale === "ca") return ca_vpn_feature_4(inputs)
	if (locale === "cs") return cs_vpn_feature_4(inputs)
	if (locale === "da") return da_vpn_feature_4(inputs)
	if (locale === "de") return de_vpn_feature_4(inputs)
	if (locale === "et") return et_vpn_feature_4(inputs)
	if (locale === "es") return es_vpn_feature_4(inputs)
	if (locale === "fr") return fr_vpn_feature_4(inputs)
	if (locale === "hr") return hr_vpn_feature_4(inputs)
	if (locale === "it") return it_vpn_feature_4(inputs)
	if (locale === "lv") return lv_vpn_feature_4(inputs)
	if (locale === "lt") return lt_vpn_feature_4(inputs)
	if (locale === "hu") return hu_vpn_feature_4(inputs)
	if (locale === "nl") return nl_vpn_feature_4(inputs)
	if (locale === "nb") return nb_vpn_feature_4(inputs)
	if (locale === "pl") return pl_vpn_feature_4(inputs)
	if (locale === "pt") return pt_vpn_feature_4(inputs)
	if (locale === "ro") return ro_vpn_feature_4(inputs)
	if (locale === "sk") return sk_vpn_feature_4(inputs)
	if (locale === "sl") return sl_vpn_feature_4(inputs)
	if (locale === "fi") return fi_vpn_feature_4(inputs)
	if (locale === "sv") return sv_vpn_feature_4(inputs)
	if (locale === "vi") return vi_vpn_feature_4(inputs)
	if (locale === "tr") return tr_vpn_feature_4(inputs)
	if (locale === "el") return el_vpn_feature_4(inputs)
	if (locale === "bg") return bg_vpn_feature_4(inputs)
	if (locale === "ru") return ru_vpn_feature_4(inputs)
	if (locale === "sr") return sr_vpn_feature_4(inputs)
	if (locale === "uk") return uk_vpn_feature_4(inputs)
	if (locale === "ka") return ka_vpn_feature_4(inputs)
	if (locale === "hi") return hi_vpn_feature_4(inputs)
	if (locale === "th") return th_vpn_feature_4(inputs)
	if (locale === "ko") return ko_vpn_feature_4(inputs)
	if (locale === "zh") return zh_vpn_feature_4(inputs)
	if (locale === "zh-tw") return zh_tw_vpn_feature_4(inputs)
	if (locale === "ja") return ja_vpn_feature_4(inputs)
	return en_vpn_feature_4(inputs)
});